import { render, staticRenderFns } from "./ProductDirectoryEntityPage.vue?vue&type=template&id=21848d50&"
import script from "./ProductDirectoryEntityPage.vue?vue&type=script&lang=ts&"
export * from "./ProductDirectoryEntityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports